import { render, staticRenderFns } from "./PageAdPlacement.vue?vue&type=template&id=2482d05c&"
import script from "./PageAdPlacement.vue?vue&type=script&lang=js&"
export * from "./PageAdPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2482d05c')) {
      api.createRecord('2482d05c', component.options)
    } else {
      api.reload('2482d05c', component.options)
    }
    module.hot.accept("./PageAdPlacement.vue?vue&type=template&id=2482d05c&", function () {
      api.rerender('2482d05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AdPlacement/PageAdPlacement.vue"
export default component.exports